"use strict";

const baseURL = process.env.REACT_APP_API_BASE_URL

const builderAnalytics = false;

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.baseURL = baseURL; 
exports.builderAnalytics = builderAnalytics;
